import React from 'react';
import SvgIcon from '../../utils/SvgIcon';
interface PaymentErrorMessageProps {
  type: string;
  heading: string;
  message: string;
}
export default function PaymentErrorMessage({ type, heading, message }: Readonly<PaymentErrorMessageProps>) {
  return (
    <div className={`portal-invoice-payment__error-message portal-invoice-payment__error-message--${type}`}>
      <div className="portal-invoice-payment__error-message-icon-wrapper">
        <SvgIcon iconName="warning-triangle" />
      </div>
      <div className="portal-invoice-payment__error-message-content">
        <h2 className="portal-invoice-payment__error-message-heading">{heading}</h2>
        <p className="portal-invoice-payment__error-message-text">{message}</p>
      </div>
    </div>
  );
}
